export default __webpack_public_path__ + "static/media/logo-small.89a99c6c.webp";